export var AgentSessionKind;
(function (AgentSessionKind) {
    AgentSessionKind["ROOT"] = "ROOT";
    AgentSessionKind["SUBAGENT"] = "SUBAGENT";
})(AgentSessionKind || (AgentSessionKind = {}));
/**
 * Lifecycle of one agent run: a single user request → model steps → subagent
 * delegations → final assistant reply. The run is the first-class authority
 * for budgets, abort, and terminal state — never derived from message scans.
 */
export var AgentRunStatus;
(function (AgentRunStatus) {
    /** A model step is streaming. */
    AgentRunStatus["Running"] = "running";
    /** Waiting on a subagent delegation. */
    AgentRunStatus["Delegating"] = "delegating";
    AgentRunStatus["Completed"] = "completed";
    AgentRunStatus["Failed"] = "failed";
    AgentRunStatus["Aborted"] = "aborted";
})(AgentRunStatus || (AgentRunStatus = {}));
//# sourceMappingURL=models.js.map